import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPlannedTerm } from '../../../global/helpers/ap_multi_plan_helper';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';

export class TermMmDeleteDialog {
  private term: IPlannedTerm;
  private isOpened: boolean = false;

  constructor(
    private ngAPNotificationDelegate: INotificationDelegate,
    private phxAxTitleAnnouncerDelegate: any,
    private deleteMmTermCommand: ICommand,
    private loadAvailableTermsCommand: ICommand
  ) {}

  closeTermDialog() {
    this.closeDialog();
  }
  deleteTerm() {
    this.closeDialog();
    const termId = _4.get(this.term, 'id', 0);
    if (!termId) {
      this.ngAPNotificationDelegate.error(`Failed to delete term.`);
      return;
    }
    this.deleteMmTermCommand(termId)
      .then((studentNk: number) => {
        this.phxAxTitleAnnouncerDelegate.announceChange(`${this.term.name} term removed`);
        this.ngAPNotificationDelegate.success(`${this.term.name} term was deleted successfully.`);
        this.loadAvailableTermsCommand(studentNk);
      })
      .catch((e) => this.ngAPNotificationDelegate.error(`Failed to delete ${this.term.name} term.`));
  }

  closeDialog() {
    this.isOpened = false;
  }
}
angular.module('capability-ng-academic-planner').component('termMmDeleteDialog', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/term_delete/term_mm_delete_dialog.html',
  bindings: {
    term: '<',
    isOpened: '='
  },
  controller: TermMmDeleteDialog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_delete/term_mm_delete_dialog.ts